const TouchLockUtil = (function () {
	return {
		lock: function ($element) {
			if (!$element.length) {
				return;
			}

			var element = $element.get(0);
			var _private = {
				last_touch_y: null,
				handleTouchStart: function (e) {
					if (!ResponsiveUtil.isToTablet()) {
						return;
					}

					if (e.targetTouches.length !== 1) {
						return;
					}

					_private.last_touch_y = e.targetTouches[0].clientY;
				},
				handleTouchMove: function (e) {
					if (!ResponsiveUtil.isToTablet()) {
						return;
					}

					if (e.targetTouches.length !== 1) {
						return;
					}

					var wrap = this;
					var diff_y = e.targetTouches[0].clientY - _private.last_touch_y;

					if (wrap.scrollTop === 0 && diff_y > 0) {
						e.preventDefault();
					}

					if (wrap.scrollHeight - wrap.scrollTop <= wrap.clientHeight && diff_y < 0) {
						e.preventDefault();
					}
				}
			};

			element.addEventListener('touchmove', _private.handleTouchMove, {passive: false});
			element.addEventListener('touchstart', _private.handleTouchStart, {passive: false});
		}
	};
})();

export default TouchLockUtil;
